import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  diagnosticRequest: null,
  diagnosticSuccess: ['data'],
  diagnosticFailure: ['error'],
});

export const DiagnosticTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  dateResponse: null,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge({fetching: true});

// we've successfully ...
export const success = (state, {data}) =>
  state.merge({
    fetching: false,
    error: null,
    data,
    dateResponse: Date.now(),
  });

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error, dateResponse: Date.now(),});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.DIAGNOSTIC_REQUEST]: request,
  [Types.DIAGNOSTIC_SUCCESS]: success,
  [Types.DIAGNOSTIC_FAILURE]: failure,
});
